import React, {Component, createRef, ReactNode} from "react"
import {filter, get} from "lodash"

import getId from "@irati/utils/id"
import {getResolvedMessage, InjectIntl, injectIntl} from "@irati/utils/lang"
import Icon, {IconTypes} from "@irati/ui/src/Icon"
import Flex from "@irati/ui/src/Flex"

import Expander, {ExpanderArrow} from "../Expander"

import {Container, Input} from "./styled"
import Option from "./styled/Option"
import PopupBox from "./styled/PopupBox"


interface Props extends InjectIntl {
  className?: string,
  small?: boolean,
  translateLabels?: boolean,
  id?: string,
  defaultValue?: string,
  header?: ReactNode,
  options: Option[],
  value: string,
  onClick: (option: Option) => void,
  icon: IconTypes
}

interface State {
  value: string,
  inFocus: boolean
}

interface Option {
  label: string,
  value: string
}

class SortBy extends Component<Props, State> {
  static defaultProps: Omit<Props, "intl" | "formatMessage" |"options" | "onClick" | "theme" | "value"> = {
    small: false,
    className: "",
    id: "",
    translateLabels: true,
    header: null
  }

  constructor(props: Props) {
    super(props)
    this.state = {
      value: props.value,
      inFocus: false
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps: Props) {
    if (nextProps.value !== this.state.value) {
      this.setState({value: nextProps.value})
    }
  }

  UNSAFE_componentWillMount() {
    window.addEventListener("click", this.handleOutsideClick)
  }

  componentWillUnmount() {
    window.removeEventListener("click", this.handleOutsideClick)
  }

  expander = createRef<Expander>()

  handleClick = (option: Option) => {
    if (this.expander.current) {
      this.expander.current.close()
    }
    this.props.onClick(option)
  }

  handleOutsideClick = ({target}: MouseEvent) => {
    if (this.expander.current) {
      if (!this.expander.current.container.current?.contains(target as Node) || !this.expander.current.state.isExpanded) {
        this.expander.current.close()
        return this.setState({inFocus: false})
      }
    }

    this.setState({inFocus: true})
  }

  labelFromValue = (value: string) => {
    const {options, translateLabels} = this.props
    const firstOption = filter(options, (test) => test.value === value)[0]
    if (!translateLabels) {
      return get(firstOption, "label")
    }
    return getResolvedMessage(this, "label", firstOption)
  }

  shouldHighlightOption = (value: string) => value === this.state.value

  render() {
    const {inFocus, value} = this.state
    const {className, id, options, icon} = this.props

    const arrow = (props: Props) => <ExpanderArrow {...props} />

    const header = () => {
      return (
        this.props.header || (
          <Flex alignItems="center">
            <Icon marginLeft={2} marginRight={2} size={16} icon={icon || IconTypes.filterUpAndDown} />
            <Input bold withEllipsis>
              {this.labelFromValue(value)}
            </Input>
          </Flex>
        )
      )
    }

    return (
      <Container className={`${className}`} inFocus={inFocus}>
        <Expander fullWidth id={id} ref={this.expander} Header={header} Arrow={arrow}>
          <PopupBox>
            {options.map((option: Option, i) => (
              <Option
                id={getId(`option${i}`, this.props)}
                key={option.value}
                addHighlight={this.shouldHighlightOption(option.value)}
                onClick={() => this.handleClick(option)}>
                <Input bold white={this.shouldHighlightOption(option.value)}>
                  {getResolvedMessage(this, "label", option)}
                </Input>
              </Option>
            ))}
          </PopupBox>
        </Expander>
      </Container>
    )
  }
}

export default injectIntl(SortBy)
